import { render, staticRenderFns } from "./MdDate.vue?vue&type=template&id=79f337b2&"
import script from "./MdDate.vue?vue&type=script&lang=js&"
export * from "./MdDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports